import api from "../../../api/clinique/_patients";

// La première page du choix patient est anticipée pendant l'ouverture du catalogue.
// Une promesse commune évite deux requêtes si l'utilisateur choisit très vite une prestation.
let premiersPatients = null
let premiersPatientsChargeA = 0
let chargementPremiersPatients = null
const filtreInitial = data => data && data.with_consultation === true && !data.search_term && (!data.page || Number(data.page) === 1)

export default {
    getPatientInsuranceInfo(patient_id) {
        return new Promise((resolve, reject) => {
            api.getPatientInsuranceInfo(patient_id).then(
                response => {
                    resolve(response);
                }, error => {
                    reject(error);
                }
            )
        })
    },

    getPatients() {
        return new Promise((resolve, reject) => {
            api.getPatients().then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    getListeAllPatient(data) {
        if (filtreInitial(data) && premiersPatients && Date.now() - premiersPatientsChargeA < 30000) return Promise.resolve(premiersPatients)
        if (filtreInitial(data) && chargementPremiersPatients) return chargementPremiersPatients
        return new Promise((resolve, reject) => {
            api.getListeAllPatient(data).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    prefetchListeAllPatient() {
        if (premiersPatients && Date.now() - premiersPatientsChargeA < 30000) return Promise.resolve(premiersPatients)
        if (chargementPremiersPatients) return chargementPremiersPatients
        chargementPremiersPatients = api.getListeAllPatient({ with_consultation: true, page: 1 })
            .then(response => {
                premiersPatients = response
                premiersPatientsChargeA = Date.now()
                return response
            }).finally(() => { chargementPremiersPatients = null })
        return chargementPremiersPatients
    },

    invaliderListePatients() {
        premiersPatients = null
        premiersPatientsChargeA = 0
    },

    getPatientForSale(params) {
        return new Promise((resolve, reject) => {
            api.getPatientForSale(params).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    /**
     * Recherche de patients pour la vente (côté serveur, au plus "limit" résultats, les plus récents d'abord)
     */
    searchPatientsForSale(search = '', limit = 30) {
        return new Promise((resolve, reject) => {
            api.searchPatientsForSale(search, limit).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    /**
     * Statistiques DMP
     * @returns 
     */
    getStatsDMP(data) {
        return new Promise((resolve, reject) => {
            api.getStatsDMP(data).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },

    /**
     * Détail paginé d'une carte des statistiques DMP
     * @returns { items, total, page, per_page }
     */
    getStatsDMPDetails(data) {
        return new Promise((resolve, reject) => {
            api.getStatsDMPDetails(data).then((response) => {
                resolve(response)
            }, error => {
                reject(error)
            });
        });
    },
}
